import React, { useState } from 'react';

const FaqPage = () => {
  const faqData = [
    {
      question: "What are your shipping options?",
      answer: "We offer Standard Shipping (5-7 business days), Express Shipping (2-3 business days), and International Shipping. Costs are calculated at checkout."
    },
    {
      question: "How can I track my order?",
      answer: "Once your order ships, you will receive an email with a tracking number and a link to monitor your package's journey."
    },
    {
      question: "What is your return policy?",
      answer: "We offer a 30-day return policy for items in their original condition. Please see our Returns & Refunds page for more details."
    },
    {
      question: "How do I initiate a return?",
      answer: "You can initiate a return by logging into your account, going to 'My Orders', and clicking 'Return Item' next to the product you wish to send back."
    },
    {
      question: "Is my payment information secure?",
      answer: "Absolutely. We use industry-standard SSL encryption to protect your personal and payment information. Your security is our top priority."
    },
    {
      question: "Do you offer international shipping?",
      answer: "Yes, we ship to many countries worldwide. Shipping fees and delivery times will vary depending on your location."
    }
  ];

  const [activeIndex, setActiveIndex] = useState(null);

  const handleToggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-3xl font-bold text-gray-800 mb-4 text-center">Frequently Asked Questions</h1>
        <p className="text-gray-600 mb-8 text-center">
          Find answers to common questions about shopping, shipping, and returns.
        </p>

        <div className="space-y-4">
          {faqData.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-md overflow-hidden transition-all duration-300"
            >
              <button
                onClick={() => handleToggle(index)}
                className="w-full flex justify-between items-center px-6 py-4 text-left focus:outline-none"
              >
                <span className="text-gray-800 font-medium">{item.question}</span>
                <span
                  className={`text-2xl font-bold transform transition-transform duration-300 ${
                    activeIndex === index ? "rotate-45" : ""
                  }`}
                >
                  +
                </span>
              </button>
              {activeIndex === index && (
                <div className="px-6 pb-4 text-gray-600 border-t border-gray-200">
                  {item.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FaqPage;
